<div nxLayout="grid maxwidth" class="cards">
  <div nxRow>
    <ng-template ngFor let-group="$implicit" [ngForOf]="groupsWPolicies" let-i="index"
      *ngIf="groupsWPolicies.length>0">
      <div [nxCol]="nxCol[group.cols]" class="cardColumn">
        <cpc-card-group>

          <cpc-card-header variant="{{ (group.name == 'car-insurance-ek')? 'ev' :'Active'}}" [title]="'active-insurance-group.' + group.name | translate"
            [badge]="'group-state.active' | translate: { count: group.count > 1 ? group.count : '' }"
            [icon]="group.icon"></cpc-card-header>

          <ng-template ngFor let-policy="$implicit" [ngForOf]="group.policies">

            <cpc-card type="entries">
              <cpc-card-entry type="entry-1">
                <span title translate>home.product-name</span>
                <b>{{policy.productNameSpecific | stringFormat}}</b>
              </cpc-card-entry>
              <container-element [ngSwitch]="group.name">
                <cpc-card-entry *ngSwitchCase="lob.CarInsurance" type="entry-2">
                  <span title translate>home.plate-number</span>
                  <b>{{policy.crn | stringFormat}}</b>
                </cpc-card-entry>
                <cpc-card-entry *ngSwitchCase="lob.LifeInsurance" type="entry-2">
                  <span title translate>home.insured-person</span>
                  <b>{{policy.firstInsuredName | stringFormat}}</b>
                </cpc-card-entry>
                <cpc-card-entry *ngSwitchCase="lob.HomeInsurance" type="entry-2">
                  <span title translate>home.address</span>
                  <b>{{policy.householdAddress | stringFormat}}</b>
                </cpc-card-entry>
                <cpc-card-entry *ngSwitchCase="lob.TravelInsurance">
                  <span title translate>{{ 'home.period.'+loggedUser.role }}</span>
                  <b>{{policy.beginDate | stringFormat | dateFormat}} - {{policy.endDate | stringFormat |
                    dateFormat}}</b>
                </cpc-card-entry>
              </container-element>

              <cpc-card-entry *ngIf="!(group.name == lob.CarInsurance && policy.leasFleetFlag == true)">
                <span title translate>home.payment-amount</span>
                <b>{{policy.premiumAmount | stringFormat | currencyFormat : policy.premiumCurrency}}</b>
              </cpc-card-entry>
              <cpc-card-entry *ngIf="!(group.name == lob.CarInsurance && policy.leasFleetFlag == true)">
                <span title translate>home.payment-status</span>
                <app-payment-status [premiumStatus]="policy.premiumStatus"></app-payment-status>
              </cpc-card-entry>
              <cpc-card-entry footer>
                <cpc-button size="small" title (click)="openPolicyDetail(policy)"><span
                    translate>home.details</span></cpc-button>
                <a href="{{policy.gatewayPaymentUrl}}" target="_blank" [class.paid]="!policy.canBePayed" *ngIf="(!['asap', 'waiting', 'overdue'].includes(policy.premiumStatus) && policy.paymentMethodId != 2) || !(group.name == lob.CarInsurance && policy.leasFleetFlag == true) ">
                  <cpc-button size="small" class="{{ commonService.compareMaturityDate(policy.premiumMaturityDate)?'green1':'' }}" mode="secondary"><span translate>home.pay-now</span></cpc-button>
                </a>
              </cpc-card-entry>
            </cpc-card>

          </ng-template>

        </cpc-card-group>
      </div>
      <ng-template [ngIf]="i===specialOfferGroupsBefore-1">
        <div nxCol="12, 12, 12, 6, 4" class="cardColumn">
          <app-special-offer [product]="specialOffer"></app-special-offer>
        </div>
      </ng-template>
    </ng-template>

    <div nxCol="12" class="cardColumn" *ngIf="groupsWPolicies.length == 0">
      <span translate>home.no-active-text</span>
    </div>

    <ng-template ngFor let-product="$implicit" [ngForOf]="inactiveProducts.slice(0, inactiveCardsToFill)">
      <div [nxCol]="nxCol[1]" class="cardColumn">
        <cpc-card-group variant="inactive">
          <cpc-card-header [title]="'inactive-products.' + product.name + '.name' | translate "
            [badge]="'group-state.inactive' | translate" [icon]="product.icon" variant="inactive">
          </cpc-card-header>
          <cpc-card>
            <p style="text-align: center">{{'inactive-products.' + product.name + '.description' | translate }}
            </p>
            <cpc-card-entry footer>
              <cpc-button size="small" title (click)="openLink(product.buyUrl, true)">
                <span translate>home.buy-insurance</span>
              </cpc-button>
              <cpc-button size="small" mode="tertiary" (click)="openLink(product.learnMoreUrl)">
                <span translate>home.learn-more</span>
                <cpc-icon icon="arrow-right"></cpc-icon>
              </cpc-button>
            </cpc-card-entry>
          </cpc-card>

        </cpc-card-group>
      </div>
    </ng-template>
  </div>

  <div nxRow>
    <div nxCol="12" class="cards-load-more">
      <cpc-button mode="tertiary" (click)="toggleLoadMore()"
        [ngClass]="loadMoreExpanded ? 'load-more-btn load-more-btn--active' : 'load-more-btn'">
        <span translate>home.see-other-offers</span>
        <cpc-icon icon="chevron-down" class="nx-margin-left-2xs"></cpc-icon>
      </cpc-button>
    </div>
  </div>

  <div [ngClass]="loadMoreExpanded ? 'product-cards--active' : 'product-cards'">
    <div nxRow>
      <ng-template ngFor let-product="$implicit" [ngForOf]="inactiveProducts.slice(inactiveCardsToFill)">
        <div [nxCol]="nxCol[1]" class="cardColumn">
          <cpc-card-group variant="inactive">
            <cpc-card-header [title]="'inactive-products.' + product.name + '.name' | translate "
              [badge]="'group-state.inactive' | translate" [icon]="product.icon" variant="inactive">
            </cpc-card-header>
            <cpc-card>
              <p style="text-align: center">{{'inactive-products.' + product.name + '.description' | translate }}
              </p>
              <cpc-card-entry footer>
                <cpc-button size="small" title (click)="openLink(product.buyUrl, true)">
                  <span translate>home.buy-insurance</span>
                </cpc-button>
                <cpc-button size="small" mode="tertiary" (click)="openLink(product.learnMoreUrl)">
                  <span translate>home.learn-more</span>
                  <cpc-icon icon="arrow-right"></cpc-icon>
                </cpc-button>
              </cpc-card-entry>
            </cpc-card>
          </cpc-card-group>
        </div>
      </ng-template>
    </div>
  </div>

  <app-help page="homepage"></app-help>
</div>
